export default function createTypedDefiner<T>() {
  return <O extends Record<string, T>>(object: O): O => object;
}
